"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var asg_1 = require("@alinta-digital/asg");
var Styles_1 = require("./Styles");
var ContentHeader = function (props) {
    var title = props.title;
    return (react_1.default.createElement(asg_1.Box, { direction: "row", margin: { vertical: 'small' } },
        react_1.default.createElement(Styles_1.StyledHeadingPF, { level: "2", "data-testid": "contentHeading" }, title)));
};
exports.default = ContentHeader;
//# sourceMappingURL=ContentHeader.js.map